import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { PersonSVGpath, BriefcaseSVGpath, AccountMultipleSVGpath } from '@skatteetaten/ds-icons';
import { TopBannerButton } from '../TopBannerButton/index.esm.js';
import './styles.css';


var styles = {
    "usernameButton": "TopBannerUserButton-module_usernameButton__SRcxp",
    "usernameText": "TopBannerUserButton-module_usernameText__u86Do"
};

const TopBannerUserButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, onClick, user }, ref)=>{
    const { t } = useTranslation('ds_layout', {
        i18n: dsI18n
    });
    const buttonText = user.role === 'meg' ? t('topbannerbutton.Myself') : user.name;
    let roleSVGpath = PersonSVGpath;
    let title = '';
    if (user.role === 'meg') {
        roleSVGpath = PersonSVGpath;
        title = t('topbannerbutton.MyselfTitle');
    } else if (user.role === 'virksomhet') {
        roleSVGpath = BriefcaseSVGpath;
        title = t('topbannerbutton.CompanyTitle');
    } else if (user.role === 'andre') {
        roleSVGpath = AccountMultipleSVGpath;
        title = t('topbannerbutton.OtherTitle');
    }
    return /*#__PURE__*/ jsx(TopBannerButton, {
        ref: ref,
        id: id,
        className: className,
        classNames: user.role === 'meg' ? undefined : {
            container: styles.usernameButton,
            text: styles.usernameText
        },
        lang: lang,
        "data-testid": dataTestId,
        variant: 'filled',
        svgPath: roleSVGpath,
        title: title,
        onClick: onClick,
        children: buttonText
    });
});
TopBannerUserButton.displayName = 'TopBannerUserButton';

export { TopBannerUserButton };
